import React from "react";
import { withTheme } from "styled-components";

export const CloseCameraIcon = ({ theme, ...props }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.1472 1.57829L19.129 0.560059L10.474 9.21504L1.81902 0.560059L0.800781 1.57829L9.45577 10.2333L0.800781 18.8883L1.81901 19.9065L10.474 11.2515L19.129 19.9065L20.1472 18.8883L11.4922 10.2333L20.1472 1.57829Z"
      fill={theme.onPrimaryColor}
    />
  </svg>
);

export default withTheme(CloseCameraIcon);
